import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Images, Refresh } from "@air/next-icons";
import { memo } from "react";
import { ASSET_MODAL_PROCESSING_TEXT } from "~/constants/testIDs";
export const NoPreviewVisualizer = /*#__PURE__*/ memo((param)=>{
    let { isProcessing } = param;
    return /*#__PURE__*/ _jsxs("div", {
        "data-testid": ASSET_MODAL_PROCESSING_TEXT,
        className: "flex min-h-[380px] flex-col items-center justify-center md:min-h-0",
        children: [
            isProcessing ? /*#__PURE__*/ _jsx(Refresh, {
                className: "size-8 animate-spin text-grey-9 motion-reduce:animate-none"
            }) : /*#__PURE__*/ _jsx(Images, {
                className: "size-16 text-grey-9"
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "mt-4 text-14 text-grey-11 md:mt-6 md:text-16",
                children: isProcessing ? "Processing... this may take a few minutes" : "No preview available"
            })
        ]
    });
});
NoPreviewVisualizer.displayName = "NoPreviewVisualizer";
